<div class="container request-access-form">
  <div class="row">
    <div class="col-sm-8">
      <h5 class="header-tab mt-3">
        {{ pageTitle }}
      </h5>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-8">
      <p>
        {{ pageText }}
      </p>
    </div>
  </div>
</div>
